import PropTypes from 'prop-types';

import { Abstrap } from '..';

const propTypes = {
    ...Abstrap.propTypes,
    type: PropTypes.oneOf(['info', 'success', 'warning', 'error']),
    inner: PropTypes.bool,
    large: PropTypes.bool,
};

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'div',
    inner: false,
    large: false,
    type: 'info',
};

class MessageBox extends Abstrap {

    getClassNameSchema() {
        const {
            inner,
            className,
            large,
            type,
        } = this.props;
        return [
            'c-msg-box',
            inner ? 'c-msg-box--inner' : false,
            large ? 'c-msg-box--large' : false,
            type ? `c-msg-box--${type}` : false,
            className,
        ];
    }

}

MessageBox.propTypes = propTypes;

MessageBox.defaultProps = defaultProps;

export default MessageBox;
